

export const APP_CLASS_NAME = 'app';
export const OSAKE_KAUPPA_LASKURI_VIEW_CLASS_NAME = 'osake-kauppa-laskuri-view';
export const NUMBER_FIELD_CLASS_NAME = 'number-field';
